import i18n from "i18next"; // Import i18next, the main library for internationalization.
import { initReactI18next } from "react-i18next"; // Import the middleware that integrates i18next with React.
import LanguageDetector from "i18next-browser-languagedetector"; // Import the language detector for browser environments.
import en from "../locales/en/translation.json"; // Import English translations from the JSON file.
import es from "../locales/es/translation.json"; // Import Spanish translations from the JSON file.
import pt from "../locales/pt/translation.json"; // Import Portuguese translations from the JSON file.


i18n.use(initReactI18next) // Use the middleware for React.
	.use(LanguageDetector) // Use the language detector to automatically detect the user's language.
	.init({
		resources: {
			en: { translation: en }, // Define translation resources for English.
			es: { translation: es }, // Define translation resources for Spanish.
			pt: { translation: pt }, // // Define translation resources for Portuguese Brazil.
			/* "pt-PT": { translation: ptPT }, // Define translation resources for Portuguese Portugal */
		},
    	lng: localStorage.getItem("i18nextLng") || undefined, // Set the default language to English.
		fallbackLng: "en", // If a translation is missing in the selected language, use English as a fallback.
		interpolation: { escapeValue: false }, // Allows value interpolation without escaping special characters.
		detection: {
			order: ["localStorage", "navigator"], // Order of detection for the user's language.
			caches: ["localStorage"], // Cache the selected language in local storage.
			convertDetectedLanguage: (lng) => { // Convert to two-letter language code.
				return lng.substring(0, 2);
			},
		},
	});

//changeLanguage('es');

export default i18n; // Export the i18next configuration so it can be used in other files.
